<template>
  <div class="dashboard-card-doppia">

    <div class="col-24 no-padding prima-card" :style="{ background: properties.bgColorUp }">
      <div class="row row-custom">
        <div class="col-6 icona" :style="{ color: properties.iconColorUp }">
          <icon :name="properties.iconaUp" scale="2.2"></icon>
        </div>
        <div class="col-14 no-padding titolo">
          {{ properties.titleUp }}
        </div>
        <div class="col-4 valore">
          {{ properties.valueUp }}
        </div>
      </div>
    </div>
    <div class="col-24 no-padding seconda-card" :style="{ background: properties.bgColorDown }">
      <div v-if="(properties.typeDown === 'Numero')">
        <div class="col-24 value-numerico">
          {{ properties.valueDown }}
        </div>
      </div>
      <div class="row row-custom" v-else>
        <div class="col-6 icona" :style="{ color: properties.iconColorDown }">
          <icon v-if="(properties.iconaDown !== '')" :name="properties.iconaDown" scale="1.5"></icon>
        </div>
        <div class="col-14 no-padding titolo">
          {{ properties.titleDown }}
        </div>
        <div class="col-4 valore">
          {{ properties.valueDown }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'DashboardCardDoppia',
    filters: {
      formatDate: function (date) {
        if (date == '') {
          return ' '
        }
        return (date.substr(0, 2) + '/' + date.substr(2, 2) + '/' + date.substr(4, 4))
      }
    },
    props: {
      properties: {
        type: Object,
        required: true,
        default: function () {
          return {
            bgColorUp: '#007c74',
            bgColorDown: '#007c74',
            iconColor: 'white',
            titleUp: 'Titolo',
            titleDown: 'Titolo',
            iconaUp: 'riv-tick',
            iconaDown: 'riv-tick',
            valueUp: '0',
            valueDown: '0'
          }
        }
      }
    },
    data () {
      return {}
    },
    methods: {}
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .dashboard-card-doppia {
    .prima-card {
      height: 70px;
      border-radius: 4px;
      .icona {
        height: 70px;
        line-height: 70px;
        text-align: left;
        margin-left: -3px;
        padding: 0px 10px !important;
      }
      .titolo {
        line-height: 70px;
        .set-font(@size: 17px, @color: @white);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .valore {
        line-height: 70px;
        .set-font(@size: 28px, @color: @white);
        text-align: right;
        padding: 0px 10px 0px 0px;
      }
    }
    .seconda-card {
      height: 45px;
      margin-top: 5px;
      border-radius: 4px;
      .icona {
        height: 45px;
        line-height: 40px;
        text-align: left;
        padding: 0px 10px !important;
      }
      .titolo {
        line-height: 45px;
        .set-font(@size: 14px, @color: @white);
      }
      .valore {
        line-height: 43px;
        .set-font(@size: 20px, @color: @white);
        text-align: right;
        padding: 0px 17px 0px 0px;
      }
      .value-numerico {
        line-height: 43px;
        .set-font(@size: 20px, @color: @white);
        text-align: center;
      }
    }
  }

  @media screen and (max-width: 1400px) and (min-width: 1250px) {
    .dashboard-card-doppia  {
      .prima-card {
        .titolo {
          line-height: 70px;
          .set-font(@size: 16px, @color: @white);
        }
      }
    }
  }

  @media screen and (max-width: 991px) and (min-width: 768px) {
    .dashboard-card-doppia  {
      .prima-card {
        .titolo {
          line-height: 70px;
          .set-font(@size: 15px, @color: @white);
        }
        .valore {
          .set-font(@size: 20px, @color: @white);
        }
      }
      .seconda-card {
        .value-numerico {
          .set-font(@size: 17px, @color: @white);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ServiceComponents/DashboardCardDoppia.vue